var React = require('react');

function CoffeeTogo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M48 160h352l-8 96H56zm330.67 256H69.33l-11-131.76 16.56 198.42A32 32 0 0 0 106.78 512h234.44a32 32 0 0 0 31.89-29.34l16.54-198.42z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M69.33 416h309.34L392 256H56zM432 64h-16l-23.16-46.31A32 32 0 0 0 364.22 0H83.78a32 32 0 0 0-28.62 17.69L32 64H16A16 16 0 0 0 0 80v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z","className":"fa-primary","key":2})]);
}

CoffeeTogo.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = CoffeeTogo;

CoffeeTogo.default = CoffeeTogo;
